import { getUserId } from '../_utils/storage_handler';
import { sendFetch, sendSellerFetch, POST_OPTIONS, GET_OPTIONS } from './base.service';

const BASE_PATH = '/users';

export const loginService = async (body) => {
    return await sendSellerFetch(`${BASE_PATH}/login`, POST_OPTIONS, body);
}

export const privateLoginService = async (body) => {
    return await sendFetch(`${BASE_PATH}/login`, POST_OPTIONS, body);
}

export const findUsersByCompany = async (company) => {
    return await sendFetch(`${BASE_PATH}/all/company/${company}`, GET_OPTIONS);
}

export const findSellersByCompany = async (company) => {
    return await sendFetch(`${BASE_PATH}/all/sellers/company/${company}`, GET_OPTIONS);
}

export const findAllUsers = async () => {
    return await sendFetch(`${BASE_PATH}/all`, GET_OPTIONS);
}

export const findNotSellersByCompany = async (company) => {
    return await sendFetch(`${BASE_PATH}/all/not-sellers/company/${company}`, GET_OPTIONS);
}

export const createUser = async (body) => {
    return await sendFetch(`${BASE_PATH}/create`, POST_OPTIONS, body);
}

export const editUser = async (body, id) => {
    return await sendFetch(`${BASE_PATH}/edit/${id}`, POST_OPTIONS, body);
}

export const findUserLogged = async () => {
    return await sendFetch(`${BASE_PATH}/id/${getUserId()}`, GET_OPTIONS);
}